import TestResultList from "../../components/TestResultList/TestResultList";

const TestResults = () => (
    <div>
        <TestResultList />
    </div>
);

export default TestResults;
